export class StreamSheetsData {
  static readonly type = '[Sheets] Stream Sheets Data';
}

export class DeleteScheduledRefresh {
  static readonly type = '[Sheets] Delete Scheduled Refresh';

  constructor(public organizationId: string, public spreadsheetId: string) {}
}
